import { render, staticRenderFns } from "./MusicVideo.vue?vue&type=template&id=173e449b&scoped=true&"
import script from "./MusicVideo.vue?vue&type=script&lang=js&"
export * from "./MusicVideo.vue?vue&type=script&lang=js&"
import style0 from "./MusicVideo.vue?vue&type=style&index=0&id=173e449b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e449b",
  null
  
)

export default component.exports